import posthog from "posthog-js";

type Primitive = string | number | boolean | null;
type TelemetryValue = Primitive | Primitive[] | Record<string, Primitive>;

export function captureClientEvent(event: string, properties?: Record<string, TelemetryValue | undefined>): void {
    try {
        posthog.capture(event, properties ?? {});
    } catch (error) {
        console.error("Failed to capture PostHog client event", { event, error });
    }
}

export function identifyClientUser(distinctId: string, properties?: Record<string, TelemetryValue | undefined>): void {
    try {
        posthog.identify(distinctId, properties ?? {});
    } catch (error) {
        console.error("Failed to identify PostHog user", { distinctId, error });
    }
}
